export default {
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: false
    },
    configuration: true,
    table: {
        clickModify: true,
        selectBtn: true,
        leftOperation: true,
        leftWidth: 200,
        height: 300,
        columns: [
            {
                label: '序号',
                prop: 'id',
                sort: true,
                width: 120,
                amendState: true
            },
            {
                label: '运单状态',
                prop: 'taskStatusName',
                sort: true,
                width: 120
            },
            {
                label: '平台名称',
                prop: 'siteName',
                sort: true,
                width: 150
            },
            {
                label: '分公司名称',
                prop: 'companyName',
                sort: true,
                width: 150
            },
            {
                label: '仓库名称',
                prop: 'whName',
                sort: true,
                width: 182
            },
            {
                label: '运输单号',
                sort: true,
                prop: 'taskNo',
                width: 200
            },
            {
                label: '物流订单号',
                sort: true,
                prop: 'waybillNo',
                width: 200
            },
            {
                label: '到车登记方式',
                sort: true,
                prop: 'arriveTypeName',
                width: 120
            },
            {
                label: '实际到车时间',
                sort: true,
                prop: 'actualArriveDate',
                width: 160
            },
            {
                label: '装货数量',
                prop: 'qtyItemLoaded',
                sort: true,
                width: 100
            },
            {
                label: '实装体积(m³)',
                prop: 'loadedVolume',
                sort: true,
                width: 120
            },
            {
                label: '实装毛重(kg)',
                prop: 'loadedGrossWeight',
                sort: true,
                width: 120
            },
            {
                label: '装车时间',
                prop: 'loadDate',
                sort: true,
                width: 160
            }
        ],
        action: {
            fixedWidth: 180,
            list: [
                {
                    type: 'text',
                    label: '明细装车',
                    size: 'mini',
                    event: 'waybillDetailedLoading',
                    ifHas: '150101024',
                    displayRule: row => {
                        // TK单状态为待装车 && 出入库为运输单(YS)、入库单(IN),显示按钮
                        const condition1 = +row.taskStatus === 20 && ['YS', 'IN'].includes(row.inOutType);
                        if (condition1) {
                            return true;
                        }
                        return false;
                    }
                },
                {
                    type: 'text',
                    label: '按运单装车确认',
                    size: 'mini',
                    event: 'waybillLoading',
                    ifHas: '150101025',
                    displayRule: row => {
                        // TK单状态为待装车 && 出入库为运输单(YS)、入库单(IN),显示按钮
                        const condition1 = +row.taskStatus === 20 && ['YS', 'IN'].includes(row.inOutType);
                        if (condition1) {
                            return true;
                        }
                        return false;
                    }
                }
            ]
        }
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    form: {
        dispatchNo: '',
        shippingType: '',
        actualcarType: '',
        iflowStatusName: '',
        suppliersNameCn: '',
        noCarCarrierName: '',
        tranName: '',
        branchName: '',
        escoCompanyNameCn: '',
        bringBackWay: '',
        remark: '',
        infoCost: ''
    }
};
